import { createAction, props } from '@ngrx/store';

import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';

// search
export const searchOrderNotLogin = createAction(
  "[Order API] search order not login",
  props<{ params: any }>()
);

export const searchOrderNotLoginSuccess = createAction(
  "[Order API] search order not login success",
  props<{ orders: OrderMstModel[] }>()
);

export const searchOrderNotLoginFailure = createAction(
  "[Order API] search order not login failure",
  props<{ msg: any }>()
);

// count
export const countOrderNotLogin = createAction(
  "[Order API] count order not login",
  props<{ params: any }>()
);

export const countOrderNotLoginSuccess = createAction(
  "[Order API] count order not login success",
  props<{ total: Number }>()
);

export const countOrderNotLoginFailure = createAction(
  "[Order API] count order not login failure",
  props<{ msg: any }>()
);

// sum
export const sumOrderNotLogin = createAction(
  "[Order API] sum order not login",
  props<{ params: any }>()
);

export const sumOrderNotLoginSuccess = createAction(
  "[Order API] sum order not login success",
  props<{ order: OrderMstModel }>()
);

export const sumOrderNotLoginFailure = createAction(
  "[Order API] sum order not login failure",
  props<{ msg: any }>()
);
